import { SurveyContext } from '@context/SurveyContext'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router'

export const useEnsureSurveyCompleted = () => {
  const { hasAcknowledged, surveyIsCompleted } = useContext(SurveyContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (!surveyIsCompleted) {
      navigate('/survey/answer')
    }
    if (hasAcknowledged === undefined) {
      navigate('/survey/acknowledge')
    }
  }, [])
}
